<template>
    <div class="site-footer">

        <p class="ac f13 c9">
            <span class="item"><a class="f-under" target="_blank" rel="nofollow"
                                  href="https://beian.miit.gov.cn/">鄂ICP备2025089731号-1</a></span>
            <!-- <span class="item split">|</span> -->
            <!-- <span class="item">
                <img :src="beianImageUrl" class="beian-img"/>
                <span class="f-under" target="_blank" rel="nofollow" href=" ">鄂公网安备 42018502005068号</span>
            </span> -->
        </p>

    </div>
</template>
<script>
import Utils from '@/utils/utils'

export default {

    data() {
        return {
            imageUrl: Utils.getPageUrl('shipinxuke'),
            beianImageUrl: require('@/assets/img/beian.png')
        }
    }
}
</script>
<style lang="less" scoped>

.site-footer {
    padding: 30px 0 10px;
}

.item + .item {
    margin-left: 10px;
}

.split {
    color: #7e7e7e;
    position: relative;
    top: -1px;
}

.beian-img{
    display: inline-block;
    vertical-align: middle;
    position: relative;
    top: -2px;
    width: 16px;
    height: auto;
}

</style>
